import { motion } from "motion/react";

const GLENDA_PHOTO = "https://customer-assets.emergentagent.com/job_heritage-global-1/artifacts/33pl9awb_glenda%20web%20.jpg";

const BITS = "10110010 01101100 11010001 00101101 10011010 01011011 00110101 11001010 01101001 10010110 01011010 00110110 10101100 01011001 10110100 00101011 11010010 01100101 10010011 01101010";

export const SobreGlendaContacto = () => {
  return (
    <section className="max-w-6xl mx-auto px-6 py-24 md:py-32">
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 items-stretch">

        <motion.div
          id="sobre-glenda"
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.9, ease: "easeOut" }}
          className="liquid-glass-strong rounded-3xl overflow-hidden flex min-h-[480px] md:min-h-[560px]"
          data-testid="section-sobre-glenda"
        >
          <div className="relative w-1/2 shrink-0">
            <img
              src={GLENDA_PHOTO}
              alt="Glenda"
              className="absolute inset-0 w-full h-full object-cover object-left"
              data-testid="glenda-photo"
            />
            <div className="absolute inset-0 bg-gradient-to-r from-transparent via-transparent to-[#0d0c0a]" />
            <div
              aria-hidden="true"
              className="absolute inset-y-0 right-0 w-2/5 overflow-hidden font-mono text-[9px] leading-4 text-[#C6A15B]/25 break-all select-none pointer-events-none pt-6 pr-2 text-right"
            >
              {BITS} {BITS} {BITS} {BITS} {BITS}
            </div>
          </div>
          <div className="flex-1 p-8 md:p-10 flex flex-col justify-center">
            <p className="text-xs uppercase tracking-[0.35em] text-[#C6A15B] mb-4">La persona detrás</p>
            <h2 className="font-serif-display text-3xl md:text-4xl text-white font-medium mb-2">
              Glenda «Cle» Palai
            </h2>
            <p className="text-sm uppercase tracking-widest text-[#C6A15B] mb-6" data-testid="glenda-role">
              Arquitecta de Destinos
            </p>
            <ul className="text-sm text-white/70 leading-relaxed space-y-2 mb-6">
              <li>Más de 25 años de trayectoria.</li>
              <li>CEO y cofundadora de Hato Cristero.</li>
              <li>Vicepresidenta de CADTEBA.</li>
              <li>Dirige Barinas Heritage Global.</li>
            </ul>
            <p className="text-xs text-white/50 leading-relaxed mb-3">
              <span className="text-white/70 uppercase tracking-wider">Presencia internacional:</span>{" "}
              WTM São Paulo · MTM Belo Horizonte · Smart City Expo Bogotá
            </p>
            <p className="text-xs text-white/50 leading-relaxed mb-8">
              <span className="text-white/70 uppercase tracking-wider">Formación:</span>{" "}
              Lic. Comercio Internacional (U.A. Humboldt) · Grado en Administración (UNA Brasil) · UNITEC · Diploma U. de Salamanca
            </p>
            <blockquote
              className="font-serif-display text-xl md:text-2xl italic text-[#C6A15B] leading-snug border-l-2 border-[#C6A15B]/40 pl-4"
              data-testid="glenda-quote"
            >
              «El lujo más alto es el silencio bien servido.»
            </blockquote>
          </div>
        </motion.div>

        <motion.div
          id="contacto"
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.9, delay: 0.15, ease: "easeOut" }}
          className="liquid-glass-strong rounded-3xl p-8 md:p-12 flex flex-col justify-center min-h-[480px] md:min-h-[560px]"
          data-testid="section-contacto"
        >
          <p className="text-xs uppercase tracking-[0.35em] text-[#C6A15B] mb-4">Conversemos</p>
          <h2 className="font-serif-display text-3xl md:text-4xl text-white font-medium mb-8">Hablemos</h2>

          <div className="mb-8">
            <p className="text-sm uppercase tracking-wider text-white font-medium mb-2">Correo</p>
            <a
              href="mailto:glendapalai@bhg-barinasheritageglobal.com"
              className="text-sm text-white/70 hover:text-[#C6A15B] transition-colors break-all"
              data-testid="contacto-email"
            >
              glendapalai@bhg-barinasheritageglobal.com
            </a>
          </div>

          <div className="mb-10">
            <p className="text-sm uppercase tracking-wider text-white font-medium mb-3">Instagram</p>
            <ul className="text-sm text-white/70 space-y-2">
              <li>
                <a href="https://instagram.com/glenda_enelmundo" target="_blank" rel="noopener noreferrer" className="hover:text-[#C6A15B] transition-colors" data-testid="contacto-ig-glenda">
                  @glenda_enelmundo <span className="text-white/40 text-xs">(personal)</span>
                </a>
              </li>
              <li>
                <a href="https://instagram.com/cadteba" target="_blank" rel="noopener noreferrer" className="hover:text-[#C6A15B] transition-colors" data-testid="contacto-ig-cadteba">
                  @cadteba
                </a>
              </li>
              <li>
                <a href="https://instagram.com/hatocristero" target="_blank" rel="noopener noreferrer" className="hover:text-[#C6A15B] transition-colors" data-testid="contacto-ig-hatocristero">
                  @hatocristero
                </a>
              </li>
              <li>
                <a href="https://instagram.com/barinasturismosalud" target="_blank" rel="noopener noreferrer" className="hover:text-[#C6A15B] transition-colors" data-testid="contacto-ig-barinasturismosalud">
                  @barinasturismosalud
                </a>
              </li>
            </ul>
          </div>

          <a
            href="mailto:glendapalai@bhg-barinasheritageglobal.com"
            data-testid="contacto-cta-conversemos"
            className="inline-flex items-center justify-center self-start rounded-full bg-[#C6A15B] px-8 py-3.5 text-sm uppercase tracking-widest text-black font-medium hover:bg-[#d9b876] transition-colors"
          >
            Conversemos
          </a>
        </motion.div>

      </div>
    </section>
  );
};
